import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { QueryClient, QueryClientProvider, Logger } from '@tanstack/react-query';

export const createTestQueryClient = ({ logger }: { logger?: Logger } = {}) =>
  new QueryClient({
    logger,
    defaultOptions: {
      queries: {
        cacheTime: Infinity,
        retry: false,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });

export function withQueryClient({ logger }: { logger?: Logger } = {}) {
  const testQueryClient = createTestQueryClient({ logger });
  return {
    testQueryClient,
    wrapper: (children: React.ReactNode) => (
      <QueryClientProvider client={testQueryClient}>{children}</QueryClientProvider>
    ),
  };
}
